// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import path from 'path';

// 引入ElementUI
import ElementUI from 'element-ui';
import  'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import $ from 'jquery';
Vue.prototype.$ = $;

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: '739ag84X2VwLAm0a2THDeX0qIMX1dOU4'
})

// 引入axios组件
import axios from 'axios'
// 自定义全局变量  在所有组件页面中可以直接使用 this.$axios去访问axios对象
Vue.prototype.$axios = axios.create({
  baseURL:'http://www.vantis.top:8080/fantisadmin',
	//baseURL:'http://116.205.103.190:8080/fantisadmin',
  //baseURL:'http://localhost:8080/fantisadmin',
	timeout:30000,  // 请求超时时间
	headers:{ // 请求参数和响应数据的格式都是json，字符编码集是utf-8
		"Content-Type":"application/json;charset=UTF-8"
	}
})


// 文件下载url变量
Vue.prototype.$fileDPath = "http://www.vantis.top:8080/fantisadmin/sys/common/static/";
//Vue.prototype.$fileDPath = "http://localhost:8080/fantisadmin/sys/common/static/";


Vue.config.productionTip = false

// 全局前置守卫
router.beforeEach((to, from, next) => {

  next();

  setTimeout(function(){
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  },500);

});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
})



// WEBPACK FOOTER //
// ./src/main.js